/**
 * Returns a responsive configuration based off of html attributes.
 * Use attributes based on tailwind's config or whatever suits you!
 * Everything before a colon is returned as a "size".
 * Ex: md:attribute="value" will return { 'md' : { 'attribute' : 'value' }}
 * All attributes without colons will be deteted as the default min size / mobile first value
 * 
 * @param  {HTMLElement} el Element from which to parse attributes
 * @return {JavaScript Object}    Responsive configuration object
 */
function parseResponsiveConfig(el) {
    let config = {};

    for (var i = el.attributes.length - 1; i >= 0; i--) {
        let split = el.attributes[i].name.split(':');
        let configCopy = config;
        for(let j=0; j < split.length-1; j++) {
            let splitPart = split[j];
            if(!configCopy[splitPart]) {
                configCopy[splitPart] = {};
            }
            configCopy = configCopy[splitPart];
        }
        configCopy[split[split.length-1]] = el.attributes[i].value;
    }

    return config;
}

/**
 * Returns a config's values filtered by correct size using min-widths
 * 
 * @param  {JavaScript Object} config {'md': {'parallax-to': 250, 'parallax-from': 150}}
 * @param  {JavaScript Object} sizes  accepts a format similar to Tailwind's config ex.: {'md': '640px'}
 * @return {JavaScript Object}        A config filtered to return only the current valid values
 */
function checkSize(config, sizes) {
    Object.keys(sizes).forEach((size,index) => {
        if(window.matchMedia('(min-width:' + sizes[size] + ')').matches){
            if(typeof config[size] !== 'undefined') {
                config = config[size];
            }
        }
    });

    return config;
}

export { parseResponsiveConfig, checkSize }